





























































































































































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Exame } from '../../../../back/src/entity/Exame';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { ConsultaPutFormData } from '../../../../back/src/types';

import Carregando from '../../components/Carregando.vue';
import Confirmar from '../../components/Confirmar.vue';
import CustomDialog from '../../components/CustomDialog.vue';
import TheGestacoesDados from '../../components/gestacoes/TheGestacoesDados.vue';
import TheConsultasDadosIndividual from '../../components/consultas/TheConsultasDadosIndividual.vue';
import TheConsultasFormCancelar from '../../components/consultas/TheConsultasFormCancelar.vue';
import TheConsultasFormIndividual from '../../components/consultas/TheConsultasFormIndividual.vue';
import TheConsultasTabelaFinalizadas from '../../components/consultas/ConsultasFinalizadasNotasProntuarioTabela.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';
import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';

export default Vue.extend({
  name: 'ConsultasAtender',
  components: {
    Carregando,
    Confirmar,
    CustomDialog,
    TheGestacoesDados,
    TheConsultasDadosIndividual,
    TheConsultasFormCancelar,
    TheConsultasFormIndividual,
    TheConsultasTabelaFinalizadas,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
  },
  data() {
    return {
      loading: {
        consulta: true,
        consultas: true,
        paciente: true,
        exames: true,
        finalizar: false,
        email: false,
      },
      dialogCancelar: false,
      dialogGestacao: false,
      dialogConsultasFinalizadas: false,
      edit: true,
      consulta: null,
      paciente: null,
      consultas: [] as Consulta[],
      exames: [] as Exame[],
      obsPreNatal: null,
      formConsulta: null,
    };
  },
  computed: {
    loadingSomething(): boolean {
      return this.loading.consulta
        || this.loading.consultas
        || this.loading.paciente
        || this.loading.exames;
    },
    divInfoButtonsClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column mb-4';
      }
      return 'd-flex mb-4';
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    consultaId(): number {
      return Number(this.$route.params.consultaId);
    },
    theConsultasFormIndividual(): Vue & { preencheForm: () => void, submitForm: () => boolean } {
      return this.$refs.theConsultasFormIndividual as Vue & {
        preencheForm: () => void,
        submitForm: () => boolean,
       };
    },
    consultasFinalizadas(): Consulta[] {
      return _.filter(this.consultas as Consulta[], consulta => (
        !!consulta.ended && !consulta.datetime_cancelamento
      ));
    },
    ultimaGestacao() {
      if (this.paciente && !this.paciente.gestacao_atual) {
        return _.maxBy(this.paciente.gestacoes as Gestacao[], gestacao => gestacao.id);
      }
      return null;
    },
  },
  async mounted() {
    this.buscaExames();
    await this.buscaConsulta();
    await this.buscaConsultas();
    await this.buscaPaciente();
  },
  methods: {
    async buscaConsulta() {
      this.loading.consulta = true;
      try {
        const response = await Requester.consulta.consulta(this.consultaId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.consulta = response.data;
          this.obsPreNatal = _.get(this.consulta, 'gestacao.obs_pre_natal', null);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.consulta = false;
      }
    },
    async buscaConsultas() {
      this.loading.consultas = true;
      try {
        const response = await Requester.paciente.consultas(this.consulta.paciente_id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.consultas = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.consultas = false;
      }
    },
    async buscaPaciente() {
      this.loading.paciente = true;
      try {
        const response = await Requester.paciente.paciente(this.consulta.paciente_id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.paciente = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.paciente = false;
      }
    },
    async buscaExames() {
      this.loading.exames = true;
      try {
        const response = await Requester.exame.exames();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.exames = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.exames = false;
      }
    },
    editForm() {
      this.theConsultasFormIndividual.preencheForm();
      this.edit = true;
    },
    atualizaConsulta(consulta: Consulta) {
      this.consulta = consulta;
      this.edit = false;
    },
    cancelaConsulta() {
      this.$router.push({ name: 'PacientesVer', params: { pacienteId: this.paciente.id } });
    },
    novoResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      this.consulta.resultados_de_exames.push(resultadoDeExame);
    },
    removeResultadoDeExame(resultadoDeExame: ResultadoDeExame) {
      const index = _.findIndex(
        this.consulta.resultados_de_exames as ResultadoDeExame[],
        resultado => (resultado.id === resultadoDeExame.id),
      );
      if (index >= 0) {
        this.$delete(this.consulta.resultados_de_exames, index);
      }
    },
    // verifica campos vazios
    camposVazios() {
      let camposVazios = '';
      if (!this.consulta.peso_gramas) {
        camposVazios += '\n - Peso';
      }
      if (!this.consulta.freq_card_materna) {
        camposVazios += '\n - Frequência cardíaca materna';
      }
      if (_.isEmpty(this.consulta.pressoes_arteriais)) {
        camposVazios += '\n - Pressão arterial';
      }
      if (this.consulta.gestacao) {
        if (!this.consulta.altura_uterina) {
          camposVazios += '\n - Altura uterina';
        }
        if (!this.consulta.edema) {
          camposVazios += '\n - Edema';
        }
        if (!this.consulta.movimento_fetal) {
          camposVazios += '\n - Movimento fetal';
        }
        if (!this.consulta.gestacao.gestacao_gemelar) {
          if (!this.consulta.bat_card_fetal1) {
            camposVazios += '\n - Batimento cardíaco fetal';
          }
          if (!this.consulta.apres_fetal1) {
            camposVazios += '\n - Apresentação fetal';
          }
          if (!this.consulta.posicao_fetal1) {
            camposVazios += '\n - Posição fetal';
          }
        } else {
          if (!this.consulta.bat_card_fetal1) {
            camposVazios += '\n - Batimento cardíaco fetal (1)';
          }
          if (!this.consulta.apres_fetal1) {
            camposVazios += '\n - Apresentação fetal (1)';
          }
          if (!this.consulta.posicao_fetal1) {
            camposVazios += '\n - Posição fetal (1)';
          }
          if (!this.consulta.bat_card_fetal2) {
            camposVazios += '\n - Batimento cardíaco fetal (2)';
          }
          if (!this.consulta.apres_fetal2) {
            camposVazios += '\n - Apresentação fetal (2)';
          }
          if (!this.consulta.posicao_fetal2) {
            camposVazios += '\n - Posição fetal (2)';
          }
        }
      }
      if (!this.consulta.queixas_condutas) {
        camposVazios += '\n - Queixas e condutas';
      }
      const resultadosDeExames = _.filter(
        this.consulta.resultados_de_exames as ResultadoDeExame[],
        resultado => (!resultado.deleted),
      );
      if (resultadosDeExames.length === 0) {
        camposVazios += '\n - Pedidos de exames';
      }
      if (!this.obsPreNatal) {
        camposVazios += '\n - Informações de destaque para a carteira de pré-natal';
      }
      if (camposVazios !== '') {
        camposVazios = `\nOs seguintes campos estão vazios:${camposVazios}`;
      }
      return camposVazios;
    },
    // eslint-disable-next-line func-names
    finalizaConsultaDebounce: _.debounce(async function () { await this.finalizaConsulta(); }, 200),
    async finalizaConsulta() {
      if (await this.confirmar.open(
        'Finalizar consulta',
        `Tem certeza que deseja finalizar esta consulta?${this.camposVazios()}`,
      ) === false) {
        return;
      }
      this.edit = false;
      this.loading.finalizar = true;
      const formData: ConsultaPutFormData = {
        id: this.consulta.id,
      };
      if (this.consulta.gestacao) {
        this.loading.email = true;
        formData.gestacao = {
          id: this.consulta.gestacao.id,
          obs_pre_natal: this.obsPreNatal,
        };
      }
      try {
        const response = await Requester.consulta.finalizaConsulta(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualizaConsulta', response.data);
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Consulta finalizada com sucesso!',
          });
          this.loading.email = false;
          this.$router.push({
            name: 'PacientesVer',
            params: { pacienteId: response.data.paciente_id },
          });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.finalizar = false;
        this.loading.email = false;
        this.edit = true;
      }
    },
  },
});
